import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { useCallback } from 'react';
import Tooltip from '@atlaskit/tooltip';
import { css, jsx } from '@emotion/react';
import { B100, DN600A, N0 } from '@atlaskit/theme/colors';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
const ColorCard = ({
  value,
  label,
  expanded,
  onClick,
  swatchSize = 'default',
  isDisabled
}) => {
  const handleMouseDown = useCallback(event => {
    event.preventDefault();
  }, []);
  const handleClick = useCallback(event => {
    event.currentTarget.focus();
    if (onClick) {
      event.preventDefault();
      onClick();
    }
  }, [onClick]);
  return jsx(Tooltip, {
    content: label
  }, jsx("button", _extends({}, getBooleanFF('platform.color-picker-radio-button-functionality_6hkcy') ? {
    css: [sharedColorContainerStyles, swatchSize === 'small' ? smallColorContainerSize : defaultColorContainerSize, colorCardButtonStyles, expanded && colorCardButtonFocusedStyles],
    disabled: isDisabled
  } : {
    css: [sharedColorContainerStyles, defaultColorContainerSize, colorCardButtonStyles, expanded && colorCardButtonFocusedStyles]
  }, {
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    "aria-label": label,
    "aria-expanded": expanded,
    "aria-haspopup": true,
    type: "button"
  }), jsx("span", {
    css: colorCardWrapperStyles
  }, jsx("span", _extends({}, getBooleanFF('platform.color-picker-radio-button-functionality_6hkcy') ? {
    css: [colorCardContentStyles, swatchSize === 'small' ? smallColorCardContentSize : defaultColorCardContentSize]
  } : {
    css: [colorCardContentStyles, defaultColorCardContentSize]
  }, {
    style: {
      background: value || 'transparent'
    }
  })))));
};
export default ColorCard;
const sharedColorContainerStyles = css({
  display: 'inline-block',
  position: 'relative',
  border: '2px solid transparent',
  boxSizing: 'border-box',
  borderRadius: '6px',
  transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
  backgroundColor: `var(--ds-background-neutral-subtle, ${N0})`,
  borderColor: `var(--ds-background-neutral-subtle, ${N0})`,
  padding: "var(--ds-space-0, 0px)",
  cursor: 'pointer',
  outline: 'none'
});
const smallColorContainerSize = css({
  width: "var(--ds-space-300, 24px)",
  height: "var(--ds-space-300, 24px)",
  top: "var(--ds-space-negative-025, -2px)"
});
const defaultColorContainerSize = css({
  width: "var(--ds-space-400, 32px)",
  height: "var(--ds-space-400, 32px)"
});
const colorCardButtonStyles = css({
  ':hover': {
    borderColor: `var(--ds-background-neutral-subtle, ${N0})`
  },
  ':not(:focus):hover, :focus': {
    borderColor: `var(--ds-border-focused, ${B100})`,
    outline: 'none'
  }
});
const colorCardButtonFocusedStyles = css({
  borderColor: `var(--ds-border-focused, ${B100})`,
  outline: 'none'
});
const colorCardWrapperStyles = css({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
const colorCardContentStyles = css({
  borderRadius: "var(--ds-border-radius-100, 3px)",
  boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${DN600A})`}`
});
const smallColorCardContentSize = css({
  width: "var(--ds-space-200, 16px)",
  height: "var(--ds-space-200, 16px)"
});
const defaultColorCardContentSize = css({
  width: "var(--ds-space-300, 24px)",
  height: "var(--ds-space-300, 24px)"
});